module.exports = __webpack_public_path__ + "media/images/athletes/2888-58f8f847b0bf621da4a23b00dc987ecb.png";